import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Label,
  Optional,
} from '@/shared/components/ui/form/components/form-label/form-label.styled';
import { TFormLabelProps } from '@/shared/components/ui/form/components/form-label/form-label.types';

export const FormLabel: React.FC<TFormLabelProps> = ({
  id,
  label,
  required,
  error,
  htmlFor,
  isFocused,
  gutterBottom = true,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <Label
      error={error}
      id={id}
      htmlFor={htmlFor}
      $isFocused={isFocused}
      $gutterBottom={gutterBottom}
      {...rest}
    >
      {label}
      {!required && <Optional>({t('ui:form.optional')})</Optional>}
    </Label>
  );
};
